import { render } from "./ProfileInfo.vue?vue&type=template&id=12b6362a&scoped=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"

import "./ProfileInfo.vue?vue&type=style&index=0&id=12b6362a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b6362a"]])

export default __exports__